import { Flex } from '@radix-ui/themes';
import { CreditsBlock } from './CreditsBlock';
import { SynopsesBlock } from './SynopsesBlock';
import { TitleBlock } from './TitleBlock';
import { ActionsBlock } from './ActionsBlock';

export const SummarySection = () => {
    return (
        <Flex direction={'column'} gap={'4'}>
            <TitleBlock />
            <SynopsesBlock /* maxHeight={'120px'}  */ />
            <CreditsBlock />
            <ActionsBlock />
        </Flex>
    );
};
